import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  icon: {
    fontSize: theme.fontSize["20"],
    margin: theme.spacing(0, 1),
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
  },
  divider: {
    backgroundColor: theme.palette.secondary.tint40,
  },
  displayImage: {
    width: theme.spacing(30),
    height: theme.spacing(30),
  },
  ToggleButtonGroup: {
    display: "flex",
    justifyContent: "space-around",
    marginBottom: theme.spacing(5),
  },
  ToggleButton: {
    border: "none !important",
    padding: "0px !important",
    "&.Mui-selected": {
      borderRadius: [theme.spacing(3), "!important"],
      padding: [theme.spacing(1), "!important"],
      border: `1.5px solid ${theme.palette.primary.main} !important`,
    },
  },
  card: {
    height: theme.spacing(24),
    width: theme.spacing(24),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    fontSize: "160%",
    cursor: "pointer",
  },
  popOver: {
    maxWidth: theme.spacing(150),
    minHeight: theme.spacing(61),
    minWidth: theme.spacing(61),
    padding: theme.spacing(10),
    borderRadius: theme.spacing(3),
    backgroundColor: theme.palette.secondary.tint90,
    color: theme.palette.secondary.tint15,
    direction: "ltr",
  },
  popOverContainer: {
    marginTop: theme.spacing(8),
    marginRight: [-theme.spacing(12), "!important"],
  },
  closeIcon: {
    backgroundColor: theme.palette.red.main,
    borderRadius: "50%",
  },
  popOverText: {
    color: theme.palette.secondary.tint15,
  },
}));
